import preval from 'preval.macro';

module.exports = require(preval`module.exports =process.env.MODALS_PATH` + "configuration")